<div class="modal-header">
  <h3 class="modal-title">Fechando a Ocorrência de Máquina</h3>
</div>
<div class="modal-body">
  <ng-include src="'views/ocorrencias_maquinas/modal/cabecalho.html'"></ng-include>
  <div class="row">
    <div class="col-xs-6 col-md-6">
      <br>
      <div class="checkbox">
        <label>
          <input type="checkbox" ng-model="ocorrencia.negligencia" id="negligencia" name="negligencia">
          Negligência?
        </label>
      </div>
    </div>

    <div class="col-xs-12">
      <textarea class="form-control" placeholder="Comentário" ng-model="ocorrencia.fechado.comentario" autofocus></textarea>
    </div>
    <div class="col-xs-12 col-md-6">
      <div class="form-group">
        <label>Data</label>
        <div class="input-group">
          <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Data"
            uib-datepicker-popup="dd/MM/yyyy" ng-model="ocorrencia.fechado.data"
            is-open="popupData.opened" show-button-bar="false">
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="popupData.opened = !popupData.opened">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>

      </div>
    </div>

    <div class="col-xs-12 col-md-6">
      <div class="form-group">
        <label>Hora</label>
        <input type="time" class="form-control" ng-model="ocorrencia.fechado.hora">
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-6">
      <label>Prazo para checagem</label>
      <div class="input-group">
        <input type="text" class="form-control" datepicker-options="datePickerOptions" placeholder="Prazo Checagem"
          uib-datepicker-popup="dd/MM/yyyy" ng-model="ocorrencia.fechado.dataPrazoChecagem"
          is-open="popupDataPrazoChecagem.opened" show-button-bar="false">
        <span class="input-group-btn">
          <button type="button" class="btn btn-default" ng-click="popupDataPrazoChecagem.opened = !popupDataPrazoChecagem.opened">
            <i class="glyphicon glyphicon-calendar"></i>
          </button>
        </span>
      </div>
    </div>
  </div>

</div>
<div class="modal-footer">
  <div class="btn btn-default btn-sm btn-action" ng-click="closeModalOcorrencia()">Cancelar</div>
  <div class="btn btn-success btn-sm btn-action" ng-click="doSaveClose()">Salvar</div>
</div>